import { GenericListQuery } from './GenericListQuery';
import { QueryModalController } from '../../../../queries/QueryModalController';
import { QueryControllerStructure } from '../../../../queries/QueryController';
import { TApiaFunction } from '@apia/util';

class UsersQuery extends GenericListQuery {
  constructor() {
    super('apia.modals.UsersAction.run');
  }

  protected getRefreshParameters(): Record<string, unknown> {
    return {
      ...super.getRefreshParameters(),
      externalUser: false,
      selectOnlyOne: false,
      globalAndEnv: true,
      hierarchy: false,
      forOrgUnit: false,
      forCurrentEnv: false,
    };
  }

  protected parseRefreshResponse(response?: TApiaFunction | null) {
    if (!response) return;

    const structure = this.parseLoadStructureResponse(response);
    this.parseStructure(structure);

    setTimeout(() => {
      super.parseRefreshResponse(response);
    }, 0);
  }

  protected getFiltersValuesMap(): Record<string, unknown> {
    return {
      ...super.getFiltersValuesMap(),
    };
  }

  protected parseLoadStructureResponse(
    response: any,
  ): QueryControllerStructure {
    const structure = { ...super.parseLoadStructureResponse(response) };
    structure.hideFilterTypes = true;
    return structure;
  }
}

export const makeApiaUsersModal2 = () =>
  new QueryModalController(new UsersQuery());
